import React from 'react';
import { Accordion } from 'react-bootstrap';

import { useGetAnswers } from 'modules/estatePlan/helpers';
import { AnswersAccordionItem } from 'modules/estatePlan/components';

import { PAGES } from 'modules/estatePlan/constants/enums';

type AnswersAccordionProps = {
  page: PAGES;
};

const AnswersAccordion = ({ page }: AnswersAccordionProps) => {
  const answers = useGetAnswers(page);

  return (
    <Accordion className="Accordion">
      {answers.map((item) => (
        <AnswersAccordionItem key={item.question} item={item} />
      ))}
    </Accordion>
  );
};

export default AnswersAccordion;
